import { LanguageCode, SUPPORTED_LANGUAGE_CODES } from '@procureai/schemas';
import { mergeDeepRight } from 'ramda';

import { appConfig } from '~/common/config';

let defaultConfig: any = {
  supportEmail: '',
  fallbackCatalogueSupplierID: '7a33d6b8-9abc-4612-af76-13f4718964ae',
  negotiationFeed: {
    pollInterval: 0,
  },
  demand: {},
  features: {},
  intercom: {
    enabled: false,
    appId: '',
    customerKey: '',
  },
  languages: [LanguageCode.de, LanguageCode.en],
};

if (appConfig.isDev) {
  defaultConfig = mergeDeepRight(defaultConfig, {
    supportEmail: 'tech@procure.ai',
    tenant: {
      geo: {
        latitude: 50.0691861,
        longitude: 8.9711199,
      },
    },
    intercom: {
      enabled: false,
      apiBase: 'https://app.eu.intercom.com/',
      appId: 'aj1ze00u',
      customerKey: 'PROCUREAI',
    },
    map: {
      style: 'mapbox://styles/mapbox/light-v10',
      zoom: 9,
    },
    filters: {
      count: 3,
    },
    demand: {
      parallelNegotiationsMax: 5,
    },
    search: {
      defaultSearchModeIsSemantic: true,
    },
    widgets: {
      strategicSpendThreshold: 20000,
    },
    features: {
      cmdi: true,
      demo: true,
      demoDataFoundation: true,
      emissions: true,
      enableCatalogPunchoutLinks: true,
      enableNegotiationObjective: true,
      fileSharing: true,
      intake: true,
      riskSustainability: true,
      showAgentCompliance: true,
      showAgentFrontdesk: true,
      showDeliveryLocation: true,
      showOrganization: true,
      smartLinks: true,
      enableEnBWSmartScaleAgent: true,
      showNewAwardingConfigurationWidget: true,
      awardableConfirmedQuotes: true,
      newFileAttachmentsWidget: true,
      enableNegotiationQuoteLineItemBidding: true,
      showDemandConversationQuickActions: true,
      enableMaterialSearch: true,
      scopeSwitcher: true,
      optionalQuotedSupplierContactLocation: true,
    },
    languages: SUPPORTED_LANGUAGE_CODES,
  });
}

export { defaultConfig };
